import { takeLatest, put, call, fork, all } from "redux-saga/effects";
import { message, notification } from "antd";
import { CaseService, CompanyService, generatePdPdf } from "services";
import { history } from "router";
import React from "react";
// import { CASE_VIEW_ACTION } from "constants";
import {
    fetchCaseDetail,
    fetchedCaseDetail,
    failedFetchCaseDetail,
    updatedCaseDetail,
    failedUpdateCaseDetail,
    fetchedChannelProductStats,
    failedFetchChannelProductsStats,
    updatedChannelProductStats,
    failedUpdateChannelProductsStats,
    updatedCaseRemarks,
    failedUpdateCaseRemarks,
    downloadedApplicationForm,
    failedDownloadApplicationForm,
    uploadedCompanyLedger,
    failedUploadCompanyLedger,
    updatedCaseQuestionnaire,
    failedUpdateCaseQuestionnaire,
    updatedCaseType,
    failedUpdateCaseType,
    fetchedCaseAssociates,
    failedFetchCaseAssociates,
    deletedCaseAssociates,
    failedDeleteCaseAssociates,
    addedCaseAssociates,
    failedAddCaseAssociates,
    fetchCaseAssociates,
    fetchedCaseDocumentChecklist,
    failedFetchCaseDocumentChecklist,
    fetchedCaseBankAccounts,
    failedFetchCaseBankAccounts,
    deletedCaseBankAccounts,
    failedDeleteCaseBankAccounts,
    addedCaseBankAccounts,
    failedAddCaseBankAccounts,
    fetchCaseBankAccounts,
    fetchedCaseRemarks,
    failedFetchCaseRemarks,
    fetchedCaseEnachMandataDetails,
    failedFetchCaseEnachMandataDetails,
    fetchedCaseEnachMandateStatus,
    failedFetchCaseEnachMandateStatus,
    fetchedCaseDetailFields,
    failedFetchCaseDetailFields,
    updatedCaseDetailFields,
    failedUpdateCaseDetailFields
} from "actions/case-details-actions";

import { fetchCompanyProfile, updateCompanyAssociates } from "../actions/company-actions";

import { updatedCompanyAssociates } from "../actions";
import { CASE_DETAILS_ACTIONS } from "constants";

function* caseDetail({ payload }) {
    try {
        const { data, error } = yield call(
            CaseService.getCaseDetail,
            payload.caseId
        );
        if (!error) {
            yield put(fetchedCaseDetail(payload.caseId, data));
        } else {
            yield put(failedFetchCaseDetail(payload.caseId, error));
        }
    } catch (error) {
        yield put(failedFetchCaseDetail(payload.caseId, error));
    }
}

function* updateCaseDetail({ payload }) {
    try {
        const { data, error } = yield call(
            CaseService.updateCaseDetail,
            payload.caseId,
            payload.caseDetail.JSONvalues
        );
        if (!error) {
            yield put(updatedCaseDetail(payload.caseId, data));
        } else {
            yield put(failedUpdateCaseDetail(payload.caseId, error));
        }
    } catch(error) {
        message.error("Case Detail Update Failed");
    }
}

function* updateCaseRemarks({ payload }) {
    try {
        const { data, error } = yield call(
            CaseService.updateCaseRemarks,
            payload.caseId,
            payload.remarks,
            payload.internalRemarks
        );
        if (!error) {
            if(payload.isManuallySaved) {
                message.success("Remarks have been updated");
            }
            yield put(updatedCaseRemarks(payload.caseId, data.remarks, data.internal_remarks));
        } else {
            yield put(failedUpdateCaseRemarks(payload.caseId, error));
        }
    } catch (error) {
        if(payload.isManuallySaved) {
            message.error("Failed to Update Remarks");
        }
        yield put(failedUpdateCaseRemarks(payload.caseId, error));
    }
}

function* getChannelProductStats({ payload: { caseId } }) {
    try {
        const { data, error } = yield call(
            CaseService.getChannelProductStat,
            caseId
        );
        if (!error) {
            yield put(fetchedChannelProductStats(caseId, data));
        } else {
            yield put(failedFetchChannelProductsStats(error));
            // message.error("Failed to Update Channel Product Stats");
        }
    } catch (error) {
        yield put(failedFetchChannelProductsStats(error));
    }
}

function* updateChannelProductStats({ payload: { caseId, channelProducts } }) {
    try {
        const { error, data } = yield call(
            CaseService.updateChannelProductStat,
            caseId,
            channelProducts
                .map(({ from_period, to_period, ...rest }) => {
                    return {
                        ...rest,
                        from_period: from_period.format("YYYY-MM-DD"),
                        to_period: to_period.format("YYYY-MM-DD")
                    };
                })
                .toList()
        );
        if (!error) {
            message.success("Channel Product Stats Updated");
            yield put(updatedChannelProductStats(caseId, data));
        } else {
            message.error("Failed to Update Channel Product Stats");
            yield put(failedUpdateChannelProductsStats(caseId, error));
        }
    } catch(e) {
        yield put(failedUpdateChannelProductsStats(caseId));
        message.error("Failed to Update Channel Product Stats");
    }
}

function* addNewChannelProduct({ payload: { product } }) {
    try {
        const { error } = yield call(
            CaseService.addNewChannelProduct,
            product
        );

        if(!error) {
            message.success("Product Added Successfully");
        } else {
            message.error("Failed to Save Product");
        }
    } catch(error) {
        message.error("Failed to Save Product");
    }
}

function* downloadApplicationForm({ payload: { caseId, application_form } }) {
    try {
        const { data } = yield call(
            CaseService.downloadApplicationFormForJana,
            caseId,
            application_form
        );
        
        if(!data) {
            message.error("Failed to download file");
        } else {
            var elem = window.document.createElement("a");
            elem.href = window.URL.createObjectURL(data);
            elem.download = "application_form.pdf";
            document.body.appendChild(elem);
            elem.click();
            document.body.removeChild(elem);
            yield put(downloadedApplicationForm(caseId));
        }
    } catch(error) {
        yield put(failedDownloadApplicationForm(caseId));
        message.error("Failed to download file");
    }
}

function* uploadCompanyLedgers({ payload: {caseId, ledgerData } }) {
    try {
        const response = yield all(
            ledgerData && ledgerData.map(_ => call(
                CompanyService.uploadLedger,
                caseId,
                _
            ))
        );
        
        yield all(
            response.map(({ data, error }) => {
                if (!error) {
                    put(uploadedCompanyLedger(caseId, data));
                    message.success("Company Ledger Uploaded");
                } else {
                    put(failedUploadCompanyLedger(caseId, error));
                    message.error("Failed to Upload Company Ledger");
                }
            })
        );

    } catch(error) {
        yield put(failedUploadCompanyLedger(caseId, error));
        message.error("Failed to Upload Company Ledger");
    }
}

function* updateCaseQuestionnaire({ payload }) {
    try {
        const { data, error } = yield call(
            CaseService.updateCaseQuestionnaire,
            payload.caseId,
            payload.questionnaire
        );
        if (!error) {
            yield put(updatedCaseQuestionnaire(payload.caseId, data));
            yield put(fetchCaseDetail(payload.caseId));
        } else {
            yield put(failedUpdateCaseQuestionnaire(payload.caseId, error));
        }
    } catch (error) {
        yield put(failedUpdateCaseQuestionnaire(payload.caseId, error));
        if (!error || !error.isWriteBlocked) {
            message.error("Case Detail Update Failed");
        }
    }
}

function* updateCaseType({ payload: { caseId, caseType } }) {
    try {
        const { data, error } = yield call(
            CaseService.updateCaseStatus,
            caseId,
            caseType
        );
        if(!error) {
            yield put(updatedCaseType(caseId, data));
            
            setTimeout(() => history.replace("/app/inbox/"), 1000);
            return;
        } 
        yield put(failedUpdateCaseType(caseId, error));
    } catch(error) {
        yield put(failedUpdateCaseType(caseId, caseType));
    }
}

function* updateProcessingFee({ payload: { caseId, proecessing_fee_amount } }) {
    message.loading("Moving Case to LMS... ", 0);
    try {
        const { error } = yield call(
            CaseService.updateProcessingFee,
            caseId,
            proecessing_fee_amount
        );
        if(!error) {
            message.destroy();
            message.success("Case successfully created to LMS");
        } else {
            message.destroy();
            message.error("Failed to Move Case to LMS");
        }
    } catch(err) {
        message.destroy();
        notification.error({
            message: "Failed to move case to LMS",
            className: "custom-class",
            style: {
                width: 700,
                marginLeft: 335 - 700,
            },
            description:
              <React.Fragment>
                  <pre id={"json"}>
                      {JSON.stringify(err, undefined, 4)}
                  </pre>
              </React.Fragment>
        });
    }
}

function* downloadCaseQuestionnaire({ payload: { caseId, data: qData }}) {
    try {
        message.info("Downloading PD file");
        const { data } = yield call(
            generatePdPdf,
            { data: qData, isBase64: false }
        );
        
        if(!data) {
            message.error("Failed to download file");
        } else {
            // var blob = new Blob(data, { type: "application/pdf" });
            var elem = window.document.createElement("a");
            elem.href = window.URL.createObjectURL(data);
            elem.download = `PD(${caseId}).pdf`;
            document.body.appendChild(elem);
            elem.click();
            document.body.removeChild(elem);

        }
    } catch(error) {
        message.error("Failed to download file");
    }
}

function* fetchCaseAssociatesHandler({payload: {caseId}}) {
    try {
        const { data, error } = yield call(
            CaseService.getCaseAssociates,
            caseId
        );
        if(!error) {
            yield put(fetchedCaseAssociates(caseId, data.results));
        } else {
            yield put(fetchedCaseAssociates(caseId, error));
        }
    } catch(error) {
        yield put(failedFetchCaseAssociates(caseId, error));
    }
}

function* addCaseAssociates({payload: {caseId, associates, companyId}}) {
    message.loading("Updating CIBIL Details.. ", 0);
    try {
        const { data, error } = yield call(
            CaseService.addCaseAssociates,
            caseId,
            associates
        );
        if(!error) {
            message.destroy();
            message.success("CIBIL Details Updated");
            yield put(addedCaseAssociates(caseId, data));
            yield put(fetchCaseAssociates(caseId));
            yield put(fetchCompanyProfile(companyId, caseId));
        } else {
            message.destroy();
            message.error("Failed to update CIBIL Details");
            yield put(failedAddCaseAssociates(caseId, data));
        }
    } catch(error) {
        message.destroy();
        message.error("Failed to update CIBIL Details");
        yield put(failedAddCaseAssociates(caseId, error));
    }
}

function* addCaseCompanyAssociates({payload: {caseId, associates, companyId, companyAssociates, address}}) {
    message.loading("Updating CIBIL Details.. ", 0);
    try {
        const { data, error } = yield call(
            CaseService.addCaseAssociates,
            caseId,
            associates
        );
        if(!error) {
            message.destroy();
            message.success("CIBIL Details Updated");
            yield put(addedCaseAssociates(caseId, data));
            yield put(fetchCaseAssociates(caseId));
            yield put(fetchCompanyProfile(companyId, caseId));
            yield put(updateCompanyAssociates(companyId, companyAssociates, address));
        } else {
            message.destroy();
            message.error("Failed to update CIBIL Details");
            yield put(failedAddCaseAssociates(caseId, data));
        }
    } catch(error) {
        message.destroy();
        message.error("Failed to update CIBIL Details");
        yield put(failedAddCaseAssociates(caseId, error));
    }
}

function* deleteCaseAssociates({payload: {caseId, associates, companyId}}) {
    try {
        const { data, error } = yield call(
            CaseService.deleteCaseAssociates,
            caseId,
            associates
        );
        if(!error) {
            yield put(deletedCaseAssociates(caseId, data));
            yield put(fetchCompanyProfile(companyId, caseId));
        } else {
            yield put(failedDeleteCaseAssociates(caseId, data));
        }
        yield put(fetchCompanyProfile(companyId, caseId));
    } catch(error) {
        yield put(failedDeleteCaseAssociates(caseId, error));
    }
}




function* fetchCaseBankAccountsHandler({payload: {caseId}}) {
    try {
        const { data, error } = yield call(
            CaseService.getCaseBankAccounts,
            caseId
        );
        if(!error) {
            yield put(fetchedCaseBankAccounts(caseId, data));
        } else {
            yield put(failedFetchCaseBankAccounts(caseId, error));
        }
    } catch(error) {
        yield put(failedFetchCaseBankAccounts(caseId, error));
    }
}

function* addCaseBankAccounts({payload: {caseId, bankAccounts}}) {
    try {
        const { data, error } = yield call(
            CaseService.addCaseBankAccounts,
            caseId,
            bankAccounts
        );
        if(!error) {
            yield put(addedCaseBankAccounts(caseId, data));
            yield put(fetchCaseBankAccounts(caseId));
        } else {
            yield put(failedAddCaseBankAccounts(caseId, data));
        }
    } catch(error) {
        yield put(failedAddCaseBankAccounts(caseId, error));
    }
}

function* deleteCaseBankAccounts({payload: {caseId, bankAccounts}}) {
    try {
        const { data, error } = yield call(
            CaseService.deleteCaseBankAccounts,
            caseId,
            bankAccounts
        );
        if(!error) {
            yield put(deletedCaseBankAccounts(caseId, data));
        } else {
            yield put(failedDeleteCaseBankAccounts(caseId, data));
        }
    } catch(error) {
        yield put(failedDeleteCaseBankAccounts(caseId, error));
    }
}

function* fetchCaseDocumentChecklist({ payload }) {
    try {
        const { data, error } = yield call(
            CaseService.fetchCaseChecklist,
            payload.caseId
        );

        if(!error) {
            yield put(fetchedCaseDocumentChecklist(payload.caseId, data));
        } else {
            yield put(failedFetchCaseDocumentChecklist(payload.caseId, data, error));
        }
    } catch(error) {
        yield put(failedFetchCaseDocumentChecklist(payload.caseId, {}, error));
    }
}


function* getCaseRemarks({ payload }) {
    try {
        const { data, error } = yield call(
            CaseService.getCaseRemarks,
            payload.caseId,
        );
        if (!error) {
            yield put(fetchedCaseRemarks(payload.caseId, data.remarks, data.internal_remarks));
        } else {
            yield put(failedFetchCaseRemarks(payload.caseId, error));
        }
    } catch (error) {
        if(payload.isManuallySaved) {
            message.error("Failed to Update Remarks");
        }
        yield put(failedFetchCaseRemarks(payload.caseId, error));
    }
}

function* fetchCaseEnachMandateDetails({ payload: { caseId, payloadData } }) {
    const { data, error } = yield call(
        CaseService.getNachMandateDetails,
        caseId,
        payloadData
    );

    if (!error) {
        yield put(
            fetchedCaseEnachMandataDetails(data, caseId)
        );
    } else {
        yield put(failedFetchCaseEnachMandataDetails(error));
    }
}

function* fetchCaseEnachMandateStatus({ payload: { caseId } }) {
    const { data, error } = yield call(
        CaseService.getEnachStatus,
        caseId,
    );

    if (!error) {
        yield put(
            fetchedCaseEnachMandateStatus(data, caseId)
        );
    } else {
        yield put(failedFetchCaseEnachMandateStatus(error));
    }
}

function* fetchCaseDetailFields({ payload }) {
    try {
        const { data, error } = yield call(
            CaseService.getCaseDetailFields,
            payload.caseId
        );
        if (!error) {
            yield put(fetchedCaseDetailFields(payload.caseId, data));
        } else {
            yield put(failedFetchCaseDetailFields(payload.caseId, error));
        }
    } catch(error) {
        message.error("Case Detail Fields Fetch Failed");
        yield put(failedFetchCaseDetailFields(payload.caseId, error));
    }
}

function* updateCaseDetailFields({ payload }) {
    try {
        const { data, error } = yield call(
            CaseService.updateCaseDetailFields,
            payload.caseId,
            payload.data
        );
        if (!error) {
            const { data: freshData, error: fetchError } = yield call(
                CaseService.getCaseDetailFields,
                payload.caseId
            );
            if (!fetchError) {
                yield put(fetchedCaseDetailFields(payload.caseId, freshData));
            } else {
                yield put(updatedCaseDetailFields(payload.caseId, data));
            }
        } else {
            yield put(failedUpdateCaseDetailFields(payload.caseId, error));
        }
    } catch(error) {
        message.error("Case Detail Fields Update Failed");
        yield put(failedUpdateCaseDetailFields(payload.caseId, error));
    }
}

export default fork(function*() {
    yield takeLatest(CASE_DETAILS_ACTIONS.FETCH_CASE_DETAILS, caseDetail);
    yield takeLatest(
        CASE_DETAILS_ACTIONS.UPDATE_CASE_DETAILS,
        updateCaseDetail
    );
    yield takeLatest(
        CASE_DETAILS_ACTIONS.FETCH_CASE_DETAIL_FIELDS,
        fetchCaseDetailFields
    );
    yield takeLatest(
        CASE_DETAILS_ACTIONS.UPDATE_CASE_DETAIL_FIELDS,
        updateCaseDetailFields
    );
    yield takeLatest(
        CASE_DETAILS_ACTIONS.UPDATE_CASE_REMARKS,
        updateCaseRemarks
    );
    yield takeLatest(
        CASE_DETAILS_ACTIONS.FETCH_CHANNEL_PRODUCT_STATS,
        getChannelProductStats
    );
    yield takeLatest(
        CASE_DETAILS_ACTIONS.UPDATE_CHANNEL_PRODUCT_STATS,
        updateChannelProductStats
    );
    yield takeLatest(
        CASE_DETAILS_ACTIONS.DOWNLOAD_APPLICATION_FORM,
        downloadApplicationForm
    );
    yield takeLatest(
        CASE_DETAILS_ACTIONS.UPDATE_COMPANY_LEDGERS,
        uploadCompanyLedgers
    );
    yield takeLatest(
        CASE_DETAILS_ACTIONS.ADD_NEW_PRODUCT,
        addNewChannelProduct
    );
    yield takeLatest(
        CASE_DETAILS_ACTIONS.UPDATE_CASE_QUESTIONNAIRE,
        updateCaseQuestionnaire
    );
    yield takeLatest(
        CASE_DETAILS_ACTIONS.DOWNLOAD_CASE_QUESTIONNAIRE,
        downloadCaseQuestionnaire
    );
    yield takeLatest(
        CASE_DETAILS_ACTIONS.UPDATE_CASE_TYPE,
        updateCaseType
    );
    yield takeLatest(
        CASE_DETAILS_ACTIONS.MOVE_CASE_TO_LMS,
        updateProcessingFee
    );
    yield takeLatest(
        CASE_DETAILS_ACTIONS.FETCH_CASE_ASSOCIATES,
        fetchCaseAssociatesHandler
    );
    yield takeLatest(
        CASE_DETAILS_ACTIONS.DELETE_CASE_ASSOCIATES,
        deleteCaseAssociates
    );
    yield takeLatest(
        CASE_DETAILS_ACTIONS.ADD_CASE_ASSOCIATES,
        addCaseAssociates
    );
    yield takeLatest(
        CASE_DETAILS_ACTIONS.ADD_CASE_COMPANY_ASSOCIATES,
        addCaseCompanyAssociates
    );

    yield takeLatest(
        CASE_DETAILS_ACTIONS.FETCH_CASE_BANK_ACCOUNTS,
        fetchCaseBankAccountsHandler
    );
    yield takeLatest(
        CASE_DETAILS_ACTIONS.DELETE_CASE_BANK_ACCOUNTS,
        deleteCaseBankAccounts
    );
    yield takeLatest(
        CASE_DETAILS_ACTIONS.ADD_CASE_BANK_ACCOUNTS,
        addCaseBankAccounts
    );
    yield takeLatest(
        CASE_DETAILS_ACTIONS.FETCH_CASE_CHECKLIST,
        fetchCaseDocumentChecklist
    );

    yield takeLatest(
        CASE_DETAILS_ACTIONS.FETCH_CASE_REMARKS,
        getCaseRemarks
    );
    yield takeLatest(
        CASE_DETAILS_ACTIONS.FETCH_CASE_NACH_MANDATE_DETAILS,
        fetchCaseEnachMandateDetails
    );
    yield takeLatest(
        CASE_DETAILS_ACTIONS.FETCH_CASE_ENACH_MANDATE_STATUS,   
        fetchCaseEnachMandateStatus
    )
});
